<template>
  <div class="virtual-office">
    <router-view />
    <SearchBar />
    <div class="content--main">
      <div class="row">
        <div class="col-4 company--list-wrapper">
          <div class="company--list">
            <div v-for="(company, i) in companies" :key="i">
              <Widget
                :widgets="company"
                @widgetClick="handleWidgetClick"
                :class="i === 0 ? 'active' : ''"
              >
                <div v-if="company.userAvatar" class="widget--avatar">
                  <img :src="company.userAvatar" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ company.companyName[0] }}</span>
                </div>
                <div class="widget--info">
                  <p class="mb-0">
                    {{ company.companyName }}
                  </p>
                  <p class="muted mb-0">
                    {{ company.members.length }} -
                    {{ company.members.length > 1 ? "members" : "member" }}
                  </p>
                </div>
              </Widget>
            </div>
          </div>
        </div>
        <div class="col-8 company--profile-wrapper">
          <div class="company--profile">
            <WidgetDetails
              :title="singlecompany.companyType"
              :widgetOptions="widgetOptions"
            >
              <div class="d-flex">
                <div v-if="singlecompany.userAvatar" class="widget--avatar">
                  <img :src="singlecompany.userAvatar" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ singlecompany.companyName[0] }}</span>
                </div>
                <div class="widget--details-wrapper">
                  <h4>
                    {{ singlecompany.companyName }}
                  </h4>
                  <p class="-muted">
                    <img
                      src="~@/assets/media/icons/user.svg"
                      alt="company icon"
                      height="20"
                      width="20"
                    />{{ singlecompany.companyIndustry }} company
                  </p>
                  <div class="row">
                    <div class="col">
                      <p>
                        <img
                          src="~@/assets/media/icons/globe.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.companyEmail }}
                      </p>
                      <p>
                        <img
                          src="~@/assets/media/icons/call.svg"
                          alt="phone icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.companyContact }}
                      </p>
                    </div>
                    <div class="col">
                      <p>
                        <img
                          src="~@/assets/media/icons/company.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.currentlyBooked }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row align-items-end justify-content-between widget--table-row mx-0"
              >
                <div class="col px-0"><h4>Member</h4></div>
                <div class="col px-0 text-right">
                  <ActionButton
                    label="Add a member"
                    class="mt-0 d-inline-block w-auto"
                    @customEvent="
                      handleAddCompanyMemberClick({
                        modal: 'admin-virtual-office-add-company-member',
                        name: 'add-company-member'
                      })
                    "
                  />
                </div>
              </div>
              <div class="row mx-0">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(member, i) in singlecompany.members" :key="i">
                        <td>{{ member.firstName }} {{ member.lastName }}</td>
                        <td>{{ member.position }}</td>
                        <td><a href="#">View member</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </WidgetDetails>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import SearchBar from "@/components/SearchBar";
import Widget from "@/modules/concierge/elements/Widget";
import WidgetDetails from "@/modules/concierge/elements/WidgetDetails";

export default {
  components: {
    SearchBar,
    Widget,
    WidgetDetails,
    ActionButton
  },
  data() {
    return {
      companies: [
        {
          companyEmail: "archer.nox@gmail.com",
          companyIndustry: "Business",
          companyType: "Virtual Office",
          userAvatar: null,
          companyContact: "63 951 153 9631",
          companyName: "Globaviations",
          currentlyBooked: "Suite 200, 29th Floor - OCC",
          members: [
            {
              firstName: "Elman",
              lastName: "Rischer",
              position: "Chief robot whisperer"
            },
            {
              firstName: "Ebbo",
              lastName: "Soames",
              position: "Director of bean-counting"
            },
            {
              firstName: "Pietro",
              lastName: "Rowley",
              position: "Software ninjaneer"
            },
            {
              firstName: "Jeffery",
              lastName: "Nutlea",
              position: "Director of first impressions"
            }
          ]
        },
        {
          companyEmail: "theodor.fade@gmail.com",
          companyIndustry: "Agriculture",
          companyType: "Virtual Office",
          userAvatar: "https://api.adorable.io/avatars/169/abott@adorable",
          companyContact: "63 941 411 9311",
          companyName: "Beedlectrics",
          currentlyBooked: "Suite 110, 8th Floor - OCC",
          members: [
            {
              firstName: "Thor",
              lastName: "Clifford",
              position: "Digital overlord"
            },
            {
              firstName: "Abdullah",
              lastName: "Beckwith",
              position: "Director of storytelling"
            },
            {
              firstName: "Kari",
              lastName: "Brownrigg",
              position: "Under Secretary to the Sub-Committee"
            }
          ]
        },
        {
          companyEmail: "jinx.hunt@gmail.com",
          companyIndustry: "Manufacturing",
          companyType: "Virtual Office",
          userAvatar: null,
          companyContact: "63 912 553 0082",
          companyName: "Neroductions",
          currentlyBooked: "Software ninjaneer",
          members: [
            {
              firstName: "Jolantha",
              lastName: "Anderton",
              position: "Master Handshaker"
            },
            {
              firstName: "Priszilla",
              lastName: "Colton",
              position: "Communications Ambassador"
            },
            {
              firstName: "Jaquelin",
              lastName: "Crutchley",
              position: "Happiness Advocate"
            }
          ]
        },
        {
          companyEmail: "scias.willow@gmail.com",
          companyIndustry: "Finance",
          companyType: "Virtual Office",
          userAvatar: null,
          companyContact: "63 905 474 1237",
          companyName: "Cannondream",
          currentlyBooked: "Suite 10, 8th Floor - OCC",
          members: [
            {
              firstName: "Marquise",
              lastName: "Adlam",
              position: "Scrum Master"
            },
            {
              firstName: "Aubrianne",
              lastName: "Spaulding",
              position: "Brand Evangelist"
            }
          ]
        }
      ],
      singlecompany: [],
      activeIndex: 0,
      widgetOptions: [
        {
          icon: "edit",
          label: "Edit Details"
        },
        {
          icon: "delete",
          label: "Deactivate"
        }
      ]
    };
  },
  created() {
    this.singlecompany = this.companies[0];
  },
  methods: {
    ...mapActions({
      changeActiveTrail: "changeActiveTrail"
    }),
    handleWidgetClick(params) {
      const { e, widget } = params;
      this.singlecompany = widget;

      [...document.querySelectorAll(".widget")].map(e => {
        e.classList.remove("active");
      });
      e.target.closest(".widget").classList.add("active");
    },
    handleAddCompanyMemberClick(params) {
      const { modal, name } = params;
      this.$router.push({ name: modal, params: { modal, name } });
    }
  }
};
</script>

<style lang="scss" scoped>
.virtual-office {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 274px
    ); /* height of viewport minus the sum of nav.header and <SearchBar/> */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    & > .row {
      height: 100%;
      div[class^="col-"] {
        height: 100%;
        overflow: auto;
      }
    }
    .company {
      &--list {
        border-radius: 5px;
      }
      &--profile {
        background-color: $gray-50;
        border-radius: 5px;
        max-height: 100%;
        overflow: auto;
        .widget--avatar {
          margin-right: 30px;
          span {
            align-items: center;
            background-color: $brand-primary;
            border-radius: 50%;
            color: $white;
            display: flex;
            font-family: "Gotham";
            font-size: $font-size-xl;
            font-weight: 500;
            height: 110px;
            justify-content: center;
            width: 110px;
          }
          img {
            border-radius: 50%;
            display: block;
            height: 110px;
            object-fit: cover;
            width: 110px;
          }
        }
        .widget--details-wrapper {
          h4 {
            color: $gray-900;
            font-size: $font-size-md;
            font-weight: 500;
            margin-bottom: 10px;
          }
          p {
            align-items: flex-start;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            img {
              margin-right: 10px;
              height: 20px;
              width: 20px;
            }
            &.-muted {
              color: $gray-550;
            }
          }
        }
        .widget--table-row {
          border-bottom: 1px solid $gray-250;
          padding: 10px 0;
          h4 {
            color: $gray-900;
            font-size: $font-size-xs;
            font-weight: 500;
          }
        }
        .table {
          font-size: $font-size-xs;
          thead {
            th {
              color: $gray-900;
              font-weight: 500;
            }
          }
          tbody {
            td {
              color: $gray-900;
              font-family: "Gotham Book";
              &.member--status {
                font-family: "Gotham";
                font-weight: 600;
                letter-spacing: 1px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
